import { render, staticRenderFns } from "./speakers.vue?vue&type=template&id=7b0d7f90"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"
import style0 from "./speakers.vue?vue&type=style&index=0&id=7b0d7f90&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports